"use client"

import Calender from "@/components/calender/Calender"

export default function DashboardPage() {
  return <Calender />
}